import { gql } from '@apollo/client'
import React from 'react'

import { fieldsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFieldsState = () => React.useContext(Context)
export const useNumberFields = () => useFieldsState()?.fields.filter(field => field.type === 'number') || []
export const useAllFields = () => useFieldsState()?.fields

const QUERY = gql`
  query Fields($origin: [String], $type: [String]) {
    fields(filter: { origins: $origin, types: $type }, limit: 999999999, sort: { field: ORDINATION, type: ASC }) {
      id
      name
      origin
      type
    }
  }
`

const normalizeOrigin = origin => (Array.isArray(origin) ? origin : origin ? [origin] : [])

const FieldsLoader = ({ children, origin }) => {
  const originVar = normalizeOrigin(origin)
  const { data, ...state } = useQuery(QUERY, {
    variables: {
      origin: originVar
    },
    client: fieldsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FieldsLoader
